import styled from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';

export const RelatedResources = styled.div`
  margin-bottom: ${layout.margins.component.desktop.rem};

  ${media.mediumDown`
  margin-bottom: ${layout.margins.component.mobile.rem};
  `}
`;
